// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { IS_MOT } from './constants';

export function setIsMot(data) {
  return {
    type: IS_MOT,
    data: data,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case IS_MOT:
      return {
        ...state,
        is_mot: action.data,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/setIsMot.js